module.exports = __webpack_public_path__ + "static/media/power.17ff51c7.mp3";